// extracted by mini-css-extract-plugin
export default {"title":"Item_title__Im7ki","wrapper":"Item_wrapper__CqSAF","content":"Item_content__KjjIp","date":"Item_date__tCFeV"};